import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fi from './locales/fi.json';
import se from './locales/se.json';
import sp from './locales/sp.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fi: { translation: fi },
      se: { translation: se },
      sp: { translation: sp },
      // The language store and selector use `es`; the locale file is sp.json (canonical Spanish).
      es: { translation: sp },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

